<nav aria-label="breadcrumb">
    <ol class="breadcrumb nav-breadcrumb pl-5">
      <li><fa-icon [icon]="faEnvelopeOpenText" class="mr-2 h2"></fa-icon></li>
      <li class="breadcrumb-item"><a routerLink="/admin" class="text-primary-color-3">{{ "home.administration" | translate }}</a></li>
      <li class="breadcrumb-item" aria-current="page"><a routerLink="/notification" class="text-primary-color-3">{{ "admin.notification" | translate }}</a></li>
    </ol>
  </nav> 
  <div class="d-flex justify-content-center pt-3">
      <div class="col-md-10">
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="bg-form shadow">
          <div class="d-flex justify-content-center">
            <div class="col-md-6 text-center">
              <h5>{{ "admin.notification" | translate }}</h5>
            </div>
          </div>
          <div class="form-group">
            <label for="title">{{ "notification.title" | translate }}:</label>
            <input class="form-control" [readonly]="view()" formControlName="title" type="text" [ngClass]="{ 'is-invalid': submitted && f.title.errors }">
            <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
                <div *ngIf="f.title.errors.required">{{ "general.required" | translate }}</div>
            </div>
          </div>
          <div class="form-group">
            <label for="message">{{ "notification.message" | translate }}:</label>
            <input class="form-control" [readonly]="view() || edit()" name="message" type="message" formControlName="message" [ngClass]="{ 'is-invalid': submitted && f.message.errors }">
            <div *ngIf="submitted && f.message.errors" class="invalid-feedback">
                <div *ngIf="f.message.errors.required">{{ "general.required" | translate }}</div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-danger mr-3" routerLink="/notification">{{ "form.cancel" | translate }}</button>
            <button type="submit" class="btn btn-primary" *ngIf="create()" >{{ "form.save" | translate }}</button>
          </div>
        </form>
      </div>
  </div>

